export default __webpack_public_path__ + "static/media/schoolinner.21ad70b8.svg";